type Props = {
  from: string;
  to: string;
  onChange: (next: { from: string; to: string }) => void;
};

export function DateRangePicker({ from, to, onChange }: Props) {
  return (
    <div className="flex items-end gap-3">
      <label className="flex flex-col gap-1.5">
        <span className="eyebrow">From</span>
        <input
          type="date"
          value={from}
          onChange={(e) => onChange({ from: e.target.value, to })}
          className="mono rounded-md border border-mars-line bg-mars-night px-3 py-1.5 text-sm text-mars-white outline-none transition-colors focus:border-mars-orange"
        />
      </label>
      <label className="flex flex-col gap-1.5">
        <span className="eyebrow">To</span>
        <input
          type="date"
          value={to}
          onChange={(e) => onChange({ from, to: e.target.value })}
          className="mono rounded-md border border-mars-line bg-mars-night px-3 py-1.5 text-sm text-mars-white outline-none transition-colors focus:border-mars-orange"
        />
      </label>
    </div>
  );
}

export function isoDaysAgo(days: number): string {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() - days);
  return d.toISOString().slice(0, 10);
}

export function isoToday(): string {
  return new Date().toISOString().slice(0, 10);
}

export function toRangeIso(from: string, to: string): { from: string; to: string } {
  return {
    from: `${from}T00:00:00.000Z`,
    to: `${to}T23:59:59.999Z`,
  };
}
